export const STORAGE_KEYS = {
  SELECTED_BILLING_ADDRESS_ID: 'selected-billing-address-id',
  SELECTED_BILLING_ADDRESS_DATA: 'selected-billing-address-data',
  SELECTED_SHIPPING_ADDRESS_ID: 'selected-shipping-address-id',
  SELECTED_SHIPPING_ADDRESS_DATA: 'selected-shipping-address-data',
  INITIAL_ADDRESS_DATA: 'initial-address-data',
  USE_SAME_BILLING_ADDRESS: 'use-same-billing-address',
  SELECTED_PAYMENT_METHOD_ID: 'selected-payment-method-id',
  SELECTED_PAYMENT_METHOD_DATA: 'selected-payment-method-data',
  SELECTED_DELIVERY_OPTIONS_MAP: 'selected-delivery-options-map',
  PHONE_NUMBER: 'phone-number',
  AGE_DATA: 'age-data',
  EMAIL: 'email',
  STORE_ADDRESS_PAYMENT_AS_DEFAULT: 'store-address-payment-as-default',
  DOI_OPT_IN: 'doi-opt-in',
  DOI_OPTED_IN_THIS_PURCHASE: 'doi-opted-in-this-purchase',
  CS_SCHEDULED_SHIPMENT_DATE: 'cs-scheduled-shipment-date',
  // OPC-specific storage keys
  OPC_SELECTED_SHIPPING_ADDRESS_DATA: 'opc-selected-shipping-address-data',
  OPC_SELECTED_BILLING_ADDRESS_DATA: 'opc-selected-billing-address-data',
  OPC_SELECTED_PAYMENT_METHOD_DATA: 'opc-selected-payment-method-data',
  OPC_EMAIL: 'opc-email',
  OPC_USE_SAME_BILLING_ADDRESS: 'opc-use-same-billing-address',
  OPC_AGE_DATA: 'opc-age-data',
  OPC_PHONE_NUMBER: 'opc-phone-number',
  OPC_DOI_OPT_IN: 'opc-doi-opt-in',
  OPC_SELECTED_DELIVERY_OPTIONS_MAP: 'opc-selected-delivery-options-map'
}

export const TEMP_PAYMENT_ID_KEY = Number.MAX_SAFE_INTEGER

export const CHECKOUT_STEPS = {
  ADDRESS: 'checkout_address',
  ADDRESS_TYPE: 'checkout_address_type',
  ADDRESS_ACTION: 'checkout_address_action',
  DELIVERY: 'checkout_delivery',
  PAYMENT: 'checkout_payment',
  PAYMENT_ACTION: 'checkout_payment_action',
  REVIEW: 'checkout_review'
}

export const CHECKOUT_GUEST_STEPS = {
  ADDRESS: 'checkout_guest_address',
  ADDRESS_TYPE: 'checkout_guest_address_type',
  ADDRESS_ACTION: 'checkout_guest_address_action',
  DELIVERY: 'checkout_guest_delivery',
  PAYMENT: 'checkout_guest_payment',
  PAYMENT_ACTION: 'checkout_guest_payment_action',
  REVIEW: 'checkout_guest_review'
}
